"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _init = require("@/api/init");
const state = {
  countries: [],
  genders: [],
  coachTools: {}
};
const mutations = {
  SET_COUNTRIES: (state, countries) => {
    state.countries = countries;
  },
  SET_GENDERS: (state, genders) => {
    state.genders = genders;
  },
  SET_COACHTOOLS: (state, coachTools) => {
    state.coachTools = coachTools;
  }
};
const actions = {
  getInitData({
    commit,
    dispatch
  }, lang) {
    return new Promise((resolve, reject) => {
      (0, _init.getInitData)(lang).then(response => {
        const data = response.data;
        commit('SET_COUNTRIES', data.facets.countries);
        commit('SET_GENDERS', data.facets.genders);
        commit('SET_COACHTOOLS', data.coachTools);
        resolve();
      }).catch(error => {
        // console.log('store-getInitData', error)
        reject(error);
      });
    });
  }
};
var _default = exports.default = {
  namespaced: true,
  state,
  mutations,
  actions
};